import { useEffect } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useFormContext, useWatch } from 'react-hook-form';
import { Create, SaveButton, SimpleForm, TextInput, Toolbar } from 'react-admin';

const schema = yup.object({
  firstName: yup
    .string()
    .max(128, 'First name is to long, max 128 characters')
    .required('First name is required'),
  lastName: yup
    .string()
    .max(128, 'Last name is to long, max 128 characters')
    .required('Last name is required'),
  email: yup.string().email().required('Email is required'),
  subject: yup
    .string()
    .max(128, 'Subject is to long, max 128 characters')
    .required('Subject is required'),
});

const QueueToolbar = (props) => {
  return (
    <Toolbar {...props}>
      <SaveButton label="Save" />
    </Toolbar>
  );
};

const FieldController = (props) => {
  const form = useFormContext();
  const asset = useWatch({ name: 'asset' });

  useEffect(() => {
    if (!asset) {
      form.setValue('published', false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asset]);

  return null;
};

const QueueCreate = (props) => {
  return (
    <Create title="Create Post">
      <SimpleForm toolbar={<QueueToolbar />} resolver={yupResolver(schema)}>
        <TextInput source="firstName" label="First Name" />
        <TextInput source="lastName" label="Last Name" />
        <TextInput source="email" label="Email Address" type="email" />
        <TextInput source="subject" />
        <FieldController {...props} />
      </SimpleForm>
    </Create>
  );
};

export default QueueCreate;
